import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { GuidItemModel, IGuidItem } from "../models/shared/guidItem";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { EntryModel } from "../models/entry/entryDTO";
import { EntryAddModel } from "../models/entry/entryAddDTO";
import { EntryActionComboModel } from "../models/entry/entryActionComboDTO";
import { EntryViewModel } from "../models/entry/entryViewDTO";
import { IEntryActionSaveDTO } from "../models/entry/entryActionSaveDTO";
import { EntryActionModel } from "../models/entry/entryActionDTO";
import { EntryUpComingEventModel } from "../models/entry/entryUpComingEventDTO";
import { EntryUpComingEventSaveModel } from "../models/entry/entryUpComingEventSaveDTO";
import { IEntryGridOption } from "../models/entry/entryGridOption";
import { IEntryAdvanceSearchDTO } from "../models/entry/entryAdvanceSearchDTO";
import { EntrySaveSearchModel } from "../models/entry/entrySaveSearchDTO";
let EntrysModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
    let EntrysModule = class EntrysModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "Entry";
            this.entries = [];
            this.totalCount = 0;
            this.states = [];
            this.types = [];
            this.statuses = [];
            this.tags = [];
            this.categories = [];
            this.categoryTagsMap = [];
            this.entry = null;
            this.entryView = null;
            this.employees = [];
            this.hightLights = [];
            this.reportsTemplate = [];
            this.gridParams = null;
            this.entryAdvanceSearchData = null;
            this.searches = [];
            this.saveSearch = null;
        }
        async GetEntries(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetEntries(plainToClass(EntryModel, data.entries));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        SetEntries(entries) {
            this.entries = entries;
        }
        async GetEntriesPrerequisites() {
            var url = `${getTenantId()}/${this.apiNode}/listing/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetStates(plainToClass(GuidItemModel, data.states));
                this.SetStatuses(plainToClass(GuidItemModel, data.statuses));
                this.SetTypes(plainToClass(GuidItemModel, data.types));
                this.SetTags(plainToClass(GuidItemModel, data.tags));
                this.SetCategories(plainToClass(GuidItemModel, data.categories));
                this.SetEmployees(plainToClass(GuidItemModel, data.employees));
                return data;
            }
        }
        SetStates(states) {
            this.states = states;
        }
        SetEmployees(employees) {
            this.employees = employees;
        }
        SetStatuses(statuses) {
            this.statuses = statuses;
        }
        SetTypes(types) {
            this.types = types;
        }
        async GettingDetailsForAddEntry() {
            var url = `${getTenantId()}/${this.apiNode}/add/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTags(plainToClass(GuidItemModel, data.tags));
                this.SetCategories(plainToClass(GuidItemModel, data.categories));
                this.SetStates(plainToClass(GuidItemModel, data.states));
                this.SetTypes(plainToClass(GuidItemModel, data.types));
                this.SetCategoryTagsMap(data.categoryTagsMap);
                return data;
            }
        }
        SetTags(tags) {
            this.tags = tags;
        }
        SetCategories(categories) {
            this.categories = categories;
        }
        SetCategoryTagsMap(categoryTagsMap) {
            this.categoryTagsMap = categoryTagsMap;
        }
        async SaveEntryAsDraft(entry) {
            var url = `${getTenantId()}/${this.apiNode}/addDraft`;
            let { data } = await service.post(url, entry);
            if (data) {
                return data;
            }
        }
        async SaveEntry(entry) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, entry);
            if (data) {
                return data;
            }
        }
        async UpsertEntryEvent(upComingEvent) {
            var url = `${getTenantId()}/${this.apiNode}/event`;
            let { data } = await service.post(url, upComingEvent);
            if (data) {
                this.SetEntryEvent(plainToClass(EntryUpComingEventModel, data.entryEvent));
                return data;
            }
        }
        async ArchiveEntries(payload) {
            var url = `${getTenantId()}/${this.apiNode}/archiveEntries`;
            let { data } = await service.post(url, payload);
            if (data) {
                return data;
            }
        }
        async unArchiveEntries(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/unArchiveEntries`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                return data;
            }
        }
        async DeleteEntryEventById(eventId) {
            var url = `${getTenantId()}/${this.apiNode}/event/` + eventId;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveEvent(eventId);
                return data;
            }
        }
        async GetEntryDetailsById(entryId) {
            var url = `${getTenantId()}/${this.apiNode}/entryDetails/` + entryId;
            let { data } = await service.get(url);
            if (data) {
                this.SetEntry(plainToClass(EntryActionComboModel, data.entry));
                return data;
            }
        }
        SetEntry(entry) {
            this.entry = entry;
        }
        async UpsertEntryAction(action) {
            var url = `${getTenantId()}/${this.apiNode}/action`;
            let { data } = await service.post(url, action);
            if (data) {
                this.SetEntryAction(plainToClass(EntryActionModel, data.entryAction));
                return data;
            }
        }
        async AddEntryAction(action) {
            var url = `${getTenantId()}/${this.apiNode}/action`;
            let { data } = await service.post(url, action);
            if (data) {
                this.AddEntryActionToView(plainToClass(EntryActionModel, data.entryAction));
                return data;
            }
        }
        SetEntryAction(entry) {
            const targetIndex = this.entry.entryActions.findIndex((x) => x.id === entry.id);
            if (targetIndex !== -1) {
                const existingEntry = this.entry.entryActions[targetIndex];
                existingEntry.description = entry.description;
                existingEntry.actionDate = entry.actionDate;
                existingEntry.actionDateAsString = entry.actionDateAsString;
            }
            else {
                this.entry.entryActions.push(entry);
            }
            this.entry.entryActions = _.orderBy(this.entry.entryActions, ["actionDate"], ["desc"]);
        }
        AddEntryActionToView(action) {
            if (this.entryView) {
                this.entryView.entryActions.push(action);
                this.entryView.entryActions = _.orderBy(this.entryView.entryActions, ["actionDate"], ["desc"]);
            }
        }
        SetFav(entryId) {
            var that = this;
            var favEntry = that.entries.find((x) => x.id == entryId);
            if (favEntry != null) {
                favEntry.isFavorite = !favEntry.isFavorite;
            }
        }
        SetEntryEvent(event) {
            const targetIndex = this.entry.upComingEvents.findIndex((x) => x.id === event.id);
            if (targetIndex !== -1) {
                const existingEvent = this.entry.upComingEvents[targetIndex];
                existingEvent.description = event.description;
                existingEvent.dueDate = event.dueDate;
                existingEvent.dueDateAsString = event.dueDateAsString;
            }
            else {
                this.entry.upComingEvents.push(event);
            }
            this.entry.upComingEvents = _.orderBy(this.entry.upComingEvents, ["dueDate"], ["desc"]);
        }
        async GetEntryDetails(entryId) {
            var url = `${getTenantId()}/${this.apiNode}/view/` + entryId;
            let { data } = await service.get(url);
            if (data) {
                this.SetEntryDetailView(plainToClass(EntryViewModel, data.viewEntry));
                return data;
            }
        }
        SetEntryDetailView(entryView) {
            this.entryView = entryView;
        }
        async DeleteEntryActionById(actionId) {
            var url = `${getTenantId()}/${this.apiNode}/deleteAction/` + actionId;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveAction(actionId);
                return data;
            }
        }
        RemoveAction(actionId) {
            const targetIndex = this.entry.entryActions.findIndex((x) => x.id === actionId);
            if (targetIndex !== -1) {
                this.entry.entryActions.splice(targetIndex, 1);
            }
        }
        RemoveEvent(eventId) {
            var existingItem = this.entry.upComingEvents.findIndex((x) => x.id == eventId);
            if (existingItem != -1) {
                this.entry.upComingEvents.splice(existingItem, 1);
            }
        }
        async UpdateEntry(payload) {
            var url = `${getTenantId()}/${this.apiNode}/updateEntry?isStatusChanged=${payload.isStatusChanged}`;
            let { data } = await service.put(url, payload.entry);
            if (data) {
                return data;
            }
        }
        async RejectEntry(entry) {
            var url = `${getTenantId()}/${this.apiNode}/reject`;
            let { data } = await service.post(url, entry);
            if (data) {
                return data;
            }
        }
        async ApproveEntry(entryId) {
            var url = `${getTenantId()}/${this.apiNode}/approve?entryId=${entryId}`;
            let { data } = await service.post(url);
            if (data) {
                return data;
            }
        }
        async AddToFavorities(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/addFavorities?entryId=${payLoad.entryId}&isFavorite=${payLoad.isFavorite}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetFav(payLoad.entryId);
                return data;
            }
        }
        async DeleteEntries(payload) {
            var url = `${getTenantId()}/${this.apiNode}/delete`;
            let { data } = await service.post(url, payload);
            if (data) {
                return data;
            }
        }
        async SaveSearch(entrySaveSearch) {
            var url = `${getTenantId()}/${this.apiNode}/saveSearch`;
            let { data } = await service.post(url, entrySaveSearch);
            if (data) {
                return data;
            }
        }
        async GetSaveSearch() {
            var url = `${getTenantId()}/${this.apiNode}/savedSearches`;
            let { data } = await service.get(url);
            if (data) {
                this.SetSearches(plainToClass(EntrySaveSearchModel, data.searches));
                return data;
            }
        }
        async DeleteSearchById(searchId) {
            var url = `${getTenantId()}/${this.apiNode}/search/` + searchId;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveSearch(searchId);
                return data;
            }
        }
        async ShareSearch(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/shareSearch?searchId=${payLoad.searchId}&isSharable=${payLoad.isSharable}`;
            let { data } = await service.put(url);
            if (data) {
                this.SetSearch(payLoad);
                return data;
            }
        }
        async GetSearchDetail(searchId) {
            var url = `${getTenantId()}/${this.apiNode}/saveSearch?searchId=${searchId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetSearchDetail(plainToClass(EntrySaveSearchModel, data.saveSearch));
                return data;
            }
        }
        SetSearchDetail(saveSearch) {
            this.saveSearch = saveSearch;
        }
        SetSearch(payLoad) {
            var existingItem = this.searches.findIndex((x) => x.id == payLoad.searchId);
            if (existingItem != -1) {
                this.searches[existingItem].isShared = payLoad.isSharable;
            }
        }
        RemoveSearch(searchId) {
            var existingItem = this.searches.findIndex((x) => x.id == searchId);
            if (existingItem != -1) {
                this.searches.splice(existingItem, 1);
            }
        }
        SetSearches(searches) {
            this.searches = searches;
        }
        ClearEntry() {
            this.entry = null;
        }
        ClearViewEntry() {
            this.entryView = null;
        }
        AssignParams(params) {
            this.gridParams = Object.assign({}, params);
        }
        ClearGridParams() {
            this.gridParams = null;
        }
        ClearAdvanceSearch() {
            this.entryAdvanceSearchData = null;
        }
        ClearSaveSearch() {
            this.saveSearch = null;
        }
        AssignAdvanceSearch(params) {
            this.entryAdvanceSearchData = Object.assign({}, params);
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IEntryGridOption !== "undefined" && IEntryGridOption) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], EntrysModule.prototype, "GetEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], EntrysModule.prototype, "GetEntriesPrerequisites", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetStates", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetEmployees", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetStatuses", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetTypes", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], EntrysModule.prototype, "GettingDetailsForAddEntry", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetTags", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetCategories", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetCategoryTagsMap", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof EntryAddModel !== "undefined" && EntryAddModel) === "function" ? _e : Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "SaveEntryAsDraft", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof EntryAddModel !== "undefined" && EntryAddModel) === "function" ? _f : Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "SaveEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof EntryUpComingEventSaveModel !== "undefined" && EntryUpComingEventSaveModel) === "function" ? _g : Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], EntrysModule.prototype, "UpsertEntryEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "ArchiveEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "unArchiveEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "DeleteEntryEventById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof Guid !== "undefined" && Guid) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], EntrysModule.prototype, "GetEntryDetailsById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof EntryActionComboModel !== "undefined" && EntryActionComboModel) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof IEntryActionSaveDTO !== "undefined" && IEntryActionSaveDTO) === "function" ? _o : Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], EntrysModule.prototype, "UpsertEntryAction", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof IEntryActionSaveDTO !== "undefined" && IEntryActionSaveDTO) === "function" ? _q : Object]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], EntrysModule.prototype, "AddEntryAction", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof EntryActionModel !== "undefined" && EntryActionModel) === "function" ? _s : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetEntryAction", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_t = typeof EntryActionModel !== "undefined" && EntryActionModel) === "function" ? _t : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "AddEntryActionToView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetFav", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_u = typeof EntryUpComingEventModel !== "undefined" && EntryUpComingEventModel) === "function" ? _u : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetEntryEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
    ], EntrysModule.prototype, "GetEntryDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_w = typeof EntryViewModel !== "undefined" && EntryViewModel) === "function" ? _w : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetEntryDetailView", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_x = typeof Guid !== "undefined" && Guid) === "function" ? _x : Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "DeleteEntryActionById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_y = typeof Guid !== "undefined" && Guid) === "function" ? _y : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "RemoveAction", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "RemoveEvent", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "UpdateEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_z = typeof IGuidItem !== "undefined" && IGuidItem) === "function" ? _z : Object]),
        __metadata("design:returntype", typeof (_0 = typeof Promise !== "undefined" && Promise) === "function" ? _0 : Object)
    ], EntrysModule.prototype, "RejectEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_1 = typeof Guid !== "undefined" && Guid) === "function" ? _1 : Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "ApproveEntry", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "AddToFavorities", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "DeleteEntries", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_2 = typeof EntrySaveSearchModel !== "undefined" && EntrySaveSearchModel) === "function" ? _2 : Object]),
        __metadata("design:returntype", Promise)
    ], EntrysModule.prototype, "SaveSearch", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_3 = typeof Promise !== "undefined" && Promise) === "function" ? _3 : Object)
    ], EntrysModule.prototype, "GetSaveSearch", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_4 = typeof Promise !== "undefined" && Promise) === "function" ? _4 : Object)
    ], EntrysModule.prototype, "DeleteSearchById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_5 = typeof Promise !== "undefined" && Promise) === "function" ? _5 : Object)
    ], EntrysModule.prototype, "ShareSearch", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_6 = typeof Promise !== "undefined" && Promise) === "function" ? _6 : Object)
    ], EntrysModule.prototype, "GetSearchDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_7 = typeof EntrySaveSearchModel !== "undefined" && EntrySaveSearchModel) === "function" ? _7 : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetSearchDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetSearch", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "RemoveSearch", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "SetSearches", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "ClearEntry", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "ClearViewEntry", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_8 = typeof IEntryGridOption !== "undefined" && IEntryGridOption) === "function" ? _8 : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "AssignParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "ClearGridParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "ClearAdvanceSearch", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "ClearSaveSearch", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_9 = typeof IEntryAdvanceSearchDTO !== "undefined" && IEntryAdvanceSearchDTO) === "function" ? _9 : Object]),
        __metadata("design:returntype", void 0)
    ], EntrysModule.prototype, "AssignAdvanceSearch", null);
    EntrysModule = __decorate([
        Module({ dynamic: true, store: store, name: "entry", namespaced: true })
    ], EntrysModule);
    return EntrysModule;
})();
export const EntryModule = getModule(EntrysModule);
